import { CircularProgress } from "@mui/material";
import React from "react";
import { Button } from "react-bootstrap";

const DeleteModal = ({
  handleSubmit,
  handleCloseModal,
  modalName,
  message = "Are you confirm?",
  loading,
}) => {
  return (
    <>
      <div className="modal-header">
        <div className="modal-title h4">{`Delete ${modalName}?`}</div>
      </div>
      <div className="text-center modal-body">{message}</div>

      <div className="modal-footer">
        <Button
          className="save-btn"
          onClick={handleCloseModal}
          variant="secondary"
        >
          No
        </Button>
        <Button
          className="close-btn"
          variant="primary"
          onClick={handleSubmit}
          disabled={loading?.isLoading}
        >
          Yes
          {loading?.isLoading && loading?.type === "submit" && (
            <CircularProgress
              size={15}
              sx={{ color: "red", marginRight: 0, marginLeft: 0.5, p: 0 }}
              disableShrink={true}
              thickness={8}
            />
          )}
        </Button>
      </div>
    </>
  );
};

export default DeleteModal;
